import { ReportConfig } from "../definitions";

const dashboard: ReportConfig = {
  id: "dashboard-2",
  name: "Dashboard CCTV 2",
  options: [
    { name: "goalQ1", label: "Q1 Goal", dataType: "text", defaultValue: "1389000", config: { hideInPrint: true } },
    { name: "goalQ2", label: "Q2 Goal", dataType: "text", defaultValue: "1562000", config: { hideInPrint: true } },
    { name: "goalQ3", label: "Q3 Goal", dataType: "text", defaultValue: "2806000", config: { hideInPrint: true } },
    { name: "goalQ4", label: "Q4 Goal", dataType: "text", defaultValue: "1443000", config: { hideInPrint: true } },
    {
      name: "lloydsMax",
      label: "LLoyds Annual Max",
      dataType: "text",
      defaultValue: "1000000",
      config: { hideInPrint: true },
    },
    {
      name: "ltcMax",
      label: "LTC Policy Max",
      dataType: "text",
      defaultValue: "25000",
      config: { hideInPrint: true },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "Carrier Paid Production YTD",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string", width: "10%" },
            { name: "Q1", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q2", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q3", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q4", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Total", type: "currency", align: "right", summary: false, width: "18%" },
          ],
          rowFormatter: [
            {
              which: -6, // current
              cellStyle: {
                fontWeight: "bold",
              },
            },
            {
              which: -4, // % goal
              style: {
                backgroundColor: "#cff",
              },
              columns: [
                { name: "", type: "string" },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
                { name: "", type: "percent", align: "right", summary: false },
              ],
            },
            {
              which: -3, // days left
              style: {
                backgroundColor: "#cff",
              },
              columns: [
                { name: "", type: "string" },
                { name: "", type: "number", align: "right", summary: false },
                { name: "", type: "number", align: "right", summary: false },
                { name: "", type: "number", align: "right", summary: false },
                { name: "", type: "number", align: "right", summary: false },
                { name: "", type: "currency", align: "right", summary: false },
              ],
            },
            {
              which: -2, // daily average
              style: {
                backgroundColor: "#cff",
              },
            },
            {
              which: -1, // diff
              style: {
                backgroundColor: "#cff",
              },
            },
          ],
          dataSource: {
            sql: `

declare @startDate date;
declare @endDate date;

-- declare @goalQ1 numeric;
-- declare @goalQ2 numeric;
-- declare @goalQ3 numeric;
-- declare @goalQ4 numeric;
declare @goalTotal numeric;

set @startDate = DATEFROMPARTS(YEAR(GETDATE()), 1, 1);
set @endDate = DATEFROMPARTS(YEAR(GETDATE()), 12, 31);
-- set @goalQ1 = 1000000;
-- set @goalQ2 = 1000000;
-- set @goalQ3 = 1000000;
-- set @goalQ4 = 1000000;
set @goalTotal = cast(@goalQ1 as numeric) +
                  cast(@goalQ2 as numeric) +
                  cast(@goalQ3 as numeric) +
                  cast(@goalQ4 as numeric);

WITH YTDPaidApplications AS (
  SELECT
    c.[Type] as [CarrierName],
    0 as [Section],
    DATEPART(Q, a.PaidOrClosedDate) as 'Q',
    COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
  FROM [awu].[Application] [a]
    INNER JOIN [dbo].CarrierType c ON a.[CarrierID] = c.[ID]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
  WHERE
    [a].[PaidOrClosedDate] BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
  GROUP BY c.[Type], DATEPART(Q, a.PaidOrClosedDate)
)

-- set @sumQ1 = (SELECT SUM(TotalPremiumPaid) FROM YTDPaidApplications WHERE Q = 1)

SELECT
    CarrierName,
    ISNULL(SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q1],
    ISNULL(SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q2],
    ISNULL(SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q3],
    ISNULL(SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q4],
    SUM([ytdp].[TotalPremiumPaid]) as [Total],
    0 as [Section]
FROM YTDPaidApplications [ytdp]
GROUP BY CarrierName

UNION

SELECT
    'Current' as [CarrierName],
    ISNULL(SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q1],
    ISNULL(SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q2],
    ISNULL(SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q3],
    ISNULL(SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] END), 0) as [Q4],
    SUM([ytdp].[TotalPremiumPaid]) as [Total],
    1 as [Section]
FROM YTDPaidApplications [ytdp]

UNION

SELECT
    'Goal' as [CarrierName],
    @goalQ1 [Q1],
    @goalQ2 [Q2],
    @goalQ3 [Q3],
    @goalQ4 [Q4],
    @goalTotal as [Total],
    2 as [Section]
FROM YTDPaidApplications [ytdp]

UNION

SELECT
    '% Goal' as [CarrierName],
    SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) / @goalQ1  AS [Q1],
    SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) / @goalQ2  AS [Q2],
    SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) / @goalQ3  AS [Q3],
    SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) / @goalQ4  AS [Q4],
    SUM([ytdp].[TotalPremiumPaid]) / @goalTotal AS [Total],
    -- @goalQ2 [Q2],
    -- @goalQ3 [Q3],
    -- @goalQ4 [Q4],
    -- @goalTotal as [Total],
    3 as [Section]
FROM YTDPaidApplications [ytdp]

UNION

SELECT 'Work Days Left',
    IIF(dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 1, 0))) > 0,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 1, 0))), null),
    IIF(dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 2, 0))) > 0,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 2, 0))), null),
    IIF(dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 3, 0))) > 0,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 3, 0))), null),
    IIF(dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 4, 0))) > 0,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 4, 0))), null),
    null,
    4

UNION

SELECT 'Daily Average',
    dbo.fn_CalcDailyAverage(
        1,
        DATEPART(Q, GETDATE()),
        SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] END),
        @goalQ1,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 1, 0)))),
    dbo.fn_CalcDailyAverage(
        2,
        DATEPART(Q, GETDATE()),
        SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] END),
        @goalQ2,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 2, 0)))),
    dbo.fn_CalcDailyAverage(
        3,
        DATEPART(Q, GETDATE()),
        SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] END),
        @goalQ3,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 3, 0)))),
    dbo.fn_CalcDailyAverage(
        4,
        DATEPART(Q, GETDATE()),
        SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] END),
        @goalQ4,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 4, 0)))),
    dbo.fn_CalcDailyAverage(
        0,
        0,
        SUM([ytdp].[TotalPremiumPaid]),
        @goalTotal,
        dbo.fn_WorkDays(GETDATE(), DATEADD (dd, -1, DATEADD(qq, DATEDIFF(qq, 0, @startDate) + 4, 0)))),
    5
FROM YTDPaidApplications [ytdp]

UNION

SELECT
    'Difference' as [CarrierName],
    @goalQ1 - SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) AS [Q1],
    @goalQ2 - SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) AS [Q2],
    @goalQ3 - SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) AS [Q3],
    @goalQ4 - SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] ELSE 0 END) AS [Q4],
    @goalTotal - SUM([ytdp].[TotalPremiumPaid])  AS [Total],
    6 as [Section]
FROM YTDPaidApplications [ytdp]



ORDER BY Section, SUM(TotalPremiumPaid) DESC


            `,
            returnType: "table",
          },
          options: { summary: false },
        },
      ],
    },
    {
      items: [
        {
          id: "item-2",
          title: "Currently in Underwriting",
          widgetType: "table",
          columns: [
            { name: "Branch", type: "string" },
            { name: "Cases", type: "number", align: "right", summary: "sum" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
SELECT
    b.[Type] as [BranchName],
    COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremium
FROM [awu].[Application] [a]
    INNER JOIN [dbo].BranchType b ON a.[BranchTypeID] = b.[ID]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
WHERE
    st.[ApplicationStatusCode] in ('A','B','J','L','S') -- in underwriting
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY b.[Type]
ORDER BY [TotalPremium] DESC
`,
            returnType: "table",
          },
          options: { summary: true },
        },
        //   ],
        // },
        // {
        //   items: [
        {
          id: "item-3",
          title: "Currently in Underwriting",
          widgetType: "table",
          columns: [
            { name: "Associate", type: "string" },
            { name: "0-30", type: "number", align: "right", summary: "sum" },
            { name: "31-44", type: "number", align: "right", summary: "sum" },
            { name: "45-90", type: "number", align: "right", summary: "sum" },
            { name: "91+", type: "number", align: "right", summary: "sum" },
            { name: "Total", type: "number", align: "right", summary: "sum" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
SELECT
    u.[FirstName] + ' ' + u.[LastName],
    SUM(CASE WHEN DATEDIFF(d,a.[EntryDate], GETDATE()) <= 30 THEN 1 ELSE 0 END ) AS '0-30',
    SUM(CASE WHEN DATEDIFF(d,a.[EntryDate], GETDATE()) BETWEEN 31 AND 44 THEN 1 ELSE 0 END) AS '31-44',
    SUM(CASE WHEN DATEDIFF(d,a.[EntryDate], GETDATE()) BETWEEN 45 AND 90 THEN 1 ELSE 0 END) AS '45-90',
    SUM(CASE WHEN DATEDIFF(d,a.[EntryDate], GETDATE()) >= 91 THEN 1 ELSE 0 END ) AS '91+',
COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremium
FROM [awu].[Application] [a]
    INNER JOIN [dbo].[User] u ON a.[CaseManager] = u.[ID]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
WHERE
    st.[ApplicationStatusCode] in ('A','B','J','L','S') -- in underwriting
    AND st.[ScenarioTypeCode] = 'F'
    AND u.[RoleTypeID] IN (5) -- underwriters only
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY u.[FirstName], u.[LastName]
ORDER BY [TotalPremium] DESC
`,
            returnType: "table",
          },
          options: { summary: true },
        },
      ],
    },
    {
      items: [
        {
          id: "item-4",
          title: "Quarterly Production - Written",
          widgetType: "table",
          columns: [
            { name: "", type: "string", summary: false, width: "10%" },
            { name: "Q1", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q2", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q3", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Q4", type: "currency", align: "right", summary: false, width: "18%" },
            { name: "Total", type: "currency", align: "right", summary: false, width: "18%" },
          ],
          dataSource: {
            sql: `
declare @startDate date;
declare @endDate date;

set @startDate = DATEFROMPARTS(YEAR(GETDATE()), 1, 1);
set @endDate = DATEFROMPARTS(YEAR(GETDATE()), 12, 31);

WITH YTDWrittenApplications AS (
  SELECT
    DATEPART(Q, a.EntryDate) as 'Q',
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS Premium
  FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
  WHERE
    a.IsDeleted IS NULL OR a.IsDeleted = 0
    AND [a].[EntryDate] BETWEEN @startDate AND @endDate
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
  GROUP BY DATEPART(Q, a.EntryDate)
)

SELECT
    '' as [Label],
    ISNULL(SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[Premium] END), 0) as [Q1],
    ISNULL(SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[Premium] END), 0) as [Q2],
    ISNULL(SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[Premium] END), 0) as [Q3],
    ISNULL(SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[Premium] END), 0) as [Q4],
    SUM([ytdp].[Premium]) as [Total]
FROM YTDWrittenApplications [ytdp]
`,
            returnType: "table",
          },
        },
      ],
    },
  ],
};

export default dashboard;
